if (window.location.href.indexOf('cart') > -1) {
  var searchParams = new URLSearchParams(window.location.search);
  if (parseInt(searchParams.get('cross_sell')) === 0) {
    $(".product-page.items_list_wrapper").remove();
  }
}

$(document).ready(function () {
  $('.addons_items').not('.slick-initialized').slick({
    variableWidth: true,
    adaptiveHeight: false,
    swipeToSlide: true,
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1650,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: false
        }
      },
      {
        breakpoint: 930,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  });
      
  $('#to_summary').click(function () {
    window.scrollTo(0, $('#main-checkout-form')[0].getClientRects()[0].top);
  });

  $('body').on('click', '#extras-add-to-basket', function(e) {
    var hasPopupCrossSellProduct = false;
    $('#promo-popup-extra-cross-sell .vtd_button').click(function () {
      hasPopupCrossSellProduct = true;
    });

    var variant_id = $(e.target).closest(".extras-atb-container").data('variant-id');
    
    $(".extras-atb-container[data-variant-id='" + variant_id + "'] .vtd_button_text").css('display', 'none');
    $(".extras-atb-container[data-variant-id='" + variant_id + "'] .vtd_button_icon").css('display', 'block');

    var data = {
      id: variant_id,
      quantity: 1
    };

    var request = {
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function(t) {
        var variant_id = t.variant_id;
        $(".extras-atb-container[data-variant-id='" + variant_id + "'] #extras-added").show();
        $(".extras-atb-container[data-variant-id='" + variant_id + "'] #extras-add-to-basket").hide();

        $(".extras-atb-container[data-variant-id='" + variant_id + "'] .vtd_button_text.add_copy").css('display', 'block');
        $(".extras-atb-container[data-variant-id='" + variant_id + "'] .vtd_button_text.price_copy").css('display', 'flex');
        $(".extras-atb-container[data-variant-id='" + variant_id + "'] .vtd_button_icon").css('display', 'none');

        $(".items_list_item .added_icon[data-product-id='" + t.product_id + "']").show();
        $(".items_list_item .added_icon[data-product-id='" + t.product_id + "']").closest(".items_list_item").addClass("item_added");

        theme.ProductPage._displayCartSuccess(t);
        theme.AjaxCart.getCartData();
        if (!hasPopupCrossSellProduct) {
          theme.Cart.showCartPopup();
        }
        
        setTimeout(function(){
          $(".extras-atb-container[data-variant-id='" + variant_id + "'] #extras-added").hide();
          $(".extras-atb-container[data-variant-id='" + variant_id + "'] #extras-add-to-basket").show();
        }, 3000);
      },
      error:function(t){ 
        console.log("Error in adding product", t);
        $(".extras-atb-container[data-variant-id='" + variant_id + "'] .vtd_button_text").css('display', 'flex');
        $(".extras-atb-container[data-variant-id='" + variant_id + "'] .vtd_button_icon").hide();
      }
    };

    jQuery.ajax(request);
  });

});
    
if ($('.items_list_item').length === 0) {
  $('.addons').hide();
}
